import { render, staticRenderFns } from "./BudgetSettingsSection.vue?vue&type=template&id=aa5c8ce0&scoped=true&"
import script from "./BudgetSettingsSection.vue?vue&type=script&setup=true&lang=js&"
export * from "./BudgetSettingsSection.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./BudgetSettingsSection.vue?vue&type=style&index=0&id=aa5c8ce0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa5c8ce0",
  null
  
)

export default component.exports